import { parseSelector } from 'vega-event-selector';
import { stringValue } from 'vega-util';
import { X, Y } from '../../channel';
import { BRUSH as INTERVAL_BRUSH } from './interval';
import { default as scalesCompiler, domain } from './scales';
var ANCHOR = '_zoom_anchor';
var DELTA = '_zoom_delta';
var zoom = {
  defined: function defined(selCmpt) {
    return selCmpt.type === 'interval' && selCmpt.zoom;
  },
  signals: function signals(model, selCmpt, _signals) {
    var name = selCmpt.name;
    var boundScales = scalesCompiler.defined(selCmpt);
    var delta = name + DELTA;
    var _selCmpt$project$hasC = selCmpt.project.hasChannel,
      x = _selCmpt$project$hasC.x,
      y = _selCmpt$project$hasC.y;
    var sx = stringValue(model.scaleName(X));
    var sy = stringValue(model.scaleName(Y));
    var events = parseSelector(selCmpt.zoom, 'scope');
    if (!boundScales) {
      events = events.map(function (e) {
        return e.markname = name + INTERVAL_BRUSH, e;
      });
    }
    _signals.push({
      name: name + ANCHOR,
      on: [{
        events: events,
        update: !boundScales ? "{x: x(unit), y: y(unit)}" : '{' + [sx ? "x: invert(".concat(sx, ", x(unit))") : '', sy ? "y: invert(".concat(sy, ", y(unit))") : ''].filter(function (expr) {
          return expr;
        }).join(', ') + '}'
      }]
    }, {
      name: delta,
      on: [{
        events: events,
        force: true,
        update: 'pow(1.001, event.deltaY * pow(16, event.deltaMode))'
      }]
    });
    if (x !== undefined) {
      onDelta(model, selCmpt, x, 'width', _signals);
    }
    if (y !== undefined) {
      onDelta(model, selCmpt, y, 'height', _signals);
    }
    return _signals;
  }
};
export default zoom;
function onDelta(model, selCmpt, proj, size, signals) {
  var _scaleCmpt$get, _scaleCmpt$get2;
  var name = selCmpt.name;
  var channel = proj.channel;
  var boundScales = scalesCompiler.defined(selCmpt);
  var signal = signals.find(function (s) {
    return s.name === proj.signals[boundScales ? 'data' : 'visual'];
  });
  var sizeSg = model.getSizeSignalRef(size).signal;
  var scaleCmpt = model.getScaleComponent(channel);
  var scaleType = scaleCmpt && scaleCmpt.get('type');
  var base = boundScales ? domain(model, channel) : signal.name;
  var delta = name + DELTA;
  var anchor = "".concat(name).concat(ANCHOR, ".").concat(channel);
  var zoomFn = !boundScales || !scaleCmpt ? 'zoomLinear' : scaleType === 'log' ? 'zoomLog' : scaleType === 'symlog' ? 'zoomSymlog' : scaleType === 'pow' ? 'zoomPow' : 'zoomLinear';
  var arg = !boundScales ? '' : scaleType === 'pow' ? ", ".concat((_scaleCmpt$get = scaleCmpt.get('exponent')) !== null && _scaleCmpt$get !== void 0 ? _scaleCmpt$get : 1) : scaleType === 'symlog' ? ", ".concat((_scaleCmpt$get2 = scaleCmpt.get('constant')) !== null && _scaleCmpt$get2 !== void 0 ? _scaleCmpt$get2 : 1) : '';
  var update = "".concat(zoomFn, "(").concat(base, ", ").concat(anchor, ", ").concat(delta).concat(arg, ")");
  signal.on.push({
    events: {
      signal: delta
    },
    update: boundScales ? update : "clampRange(".concat(update, ", 0, ").concat(sizeSg, ")")
  });
}